module.exports = __webpack_public_path__ + "static/media/crane6.389452a2.png";